import { catchError } from "@opendash/core";
import { useTranslation } from "@opendash/i18n";
import { Descriptions, List } from "antd";
import { DescriptionsItemType } from "antd/es/descriptions";
import dayjs from "dayjs";
import { observer } from "mobx-react-lite";
import Parse from "parse";
import React, { Fragment, useEffect } from "react";
import {
  Schedule_Execution,
  Schedule_Execution_Step,
} from "../../../js/parsegenerated";

type Props = {
  execution: Schedule_Execution;
};

export default observer((props: Props) => {
  const t = useTranslation();
  const [steps, setSteps] = React.useState<Schedule_Execution_Step[]>([]);

  useEffect(() => {
    if (props.execution === undefined) {
      return;
    }

    //Get all steps
    catchError(
      new Parse.Query(Schedule_Execution_Step)
        .equalTo("scheduleexecution", props.execution)
        .find()
    ).then((stepsresult) => {
      setSteps(stepsresult[1]);
    });
  }, [props.execution]);

  const items: DescriptionsItemType[] = [
    {
      label: t("maintenance:machinelog.scheduleexecutiondetails.finishedAt"),
      children: props.execution.get("finishedAt")
        ? dayjs(props.execution.get("finishedAt")).format("DD.MM.YYYY HH:mm")
        : "",
    },
    {
      label: t("maintenance:machinelog.scheduleexecutiondetails.title"),
      children: props.execution.get("title"),
    },
    {
      label: t("maintenance:machinelog.scheduleexecutiondetails.description"),
      children: props.execution.get("description"),
    },
    {
      label: t("maintenance:machinelog.scheduleexecutiondetails.steps"),
      children: (
        <List>
          {steps.map((step, index) => (
            <List.Item key={step.id + index}>
              <List.Item.Meta
                title={`${index + 1}. ${step.title}`}
                description={step.description}
              />
            </List.Item>
          ))}
        </List>
      ),
    },
    {
      label: t("maintenance:machinelog.scheduleexecutiondetails.material"),
      children: (
        <List>
          {props.execution.get("material")?.map((material, index) => (
            <Fragment key={material.id + index}>
              {material?.name && material.amount && (
                <List.Item key={material.id + index}>
                  {material.name} ({material.amount} {material.unit ?? "x"})
                </List.Item>
              )}
            </Fragment>
          ))}
        </List>
      ),
    },
  ];

  return <Descriptions items={items} layout="vertical" column={1} bordered />;
});
